export const convertSecondsToTime = (totalSeconds: number): string => {
  const totalSecondsInt = Math.floor(totalSeconds);
  const minutes = Math.floor(totalSecondsInt / 60);
  const seconds = totalSecondsInt % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
    2,
    '0',
  )}`;
};
